import React, { ReactElement } from 'react'

const ConditionalLink = ({
  link,
  children,
}: {
  link?: string
  children: ReactElement
}) => {
  if (!link) return children

  return (
    <a href={link} target="_blank" rel="noopener noreferrer">
      {children}
    </a>
  )
}

export default ConditionalLink
